<template>
<b-col class="wrapper-breadcrumbb" cols="12">
    <b-container>
        <b-row>
            <ul class="breadcrumbb" v-if="collection.length">
                <li v-for="(item, index) in collection" :key="index">
                    <template v-if="!(index==collection.length-1)">
                        <router-link :to="item.url"
                          @click.native="track(`${item.url}`,'clicou_url_breadcrumb'),
                          buttonClicked()">
                            <span class="text-regular">{{ item.name }}</span>
                        </router-link>
                        <span class="arrow"> > </span>
                    </template>
                    <template v-else>
                        <strong
                          :class="['text-regular font-weight-bold', {'mobile' : checkMobile(576)}]">
                          {{ checkMobile(576) ? nameFormatter(item.name) :  item.name }}
                        </strong>
                    </template>
                </li>
            </ul>
        </b-row>
    </b-container>
</b-col>
</template>
<script>
import { truncateString } from '@/utils/stringUtils';

export default {
  name: 'Breadcrumb',
  props: {
    collection: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    nameFormatter(name) {
      return truncateString(name, 42);
    },
    checkMobile(size) {
      return (window.innerWidth <= size);
    },
    buttonClicked() {
      this.$emit('button-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-breadcrumbb{
    border-bottom:$bg-light-grey 1px solid;
    .breadcrumbb{
        display: flex;
        flex-wrap: wrap;
        padding-left: 0;
        list-style-type: none;
        margin-bottom: 0;
        margin-top: 10px;
        color: $text-dark;
        .arrow{
            padding: 0 2px;
        }
        li{
          .mobile{
            line-height: 28px;
          }
        }
    }
}
</style>
